import type { Job } from '@/gen/cortado/v1/jobs_pb'
import type { Quote } from '@/gen/cortado/v1/invoices_pb'

/** `$quoteId` on `/pipeline/$id/quotes/$quoteId` that drafts a new quote for the job. */
export const NEW_QUOTE_ID = 'new'

/**
 * `?start=` for a new quote drafted from the request alone (its events and the
 * lead's picked items), with no template. Any other value is a template id;
 * none uses the template matching the inquiry's event type, if there is one.
 */
export const NEW_QUOTE_FROM_REQUEST = 'request'

/** A quote opened under a job must be one of that job's quotes. */
export function quoteBelongsToJob(quote: Quote, job: Job): boolean {
  if (quote.jobId) return quote.jobId === job.id
  return job.quoteIds.includes(quote.id) || (!!job.inquiryId && quote.inquiryId === job.inquiryId)
}
